/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Gdpr_LabelInputs */

const en_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliant`)
};

const de_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konform`)
};

const fr_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conforme`)
};

const es_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conforme`)
};

const it_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conforme`)
};

const nl_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conform`)
};

const pl_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodny`)
};

const fi_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhdenmukainen`)
};

const da_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel`)
};

const sv_landing_stat_gdpr_label = /** @type {(inputs: Landing_Stat_Gdpr_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompatibel`)
};

/**
* | output |
* | --- |
* | "Compliant" |
*
* @param {Landing_Stat_Gdpr_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_gdpr_label = /** @type {((inputs?: Landing_Stat_Gdpr_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Gdpr_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_gdpr_label(inputs)
	if (locale === "fr") return fr_landing_stat_gdpr_label(inputs)
	if (locale === "es") return es_landing_stat_gdpr_label(inputs)
	if (locale === "it") return it_landing_stat_gdpr_label(inputs)
	if (locale === "nl") return nl_landing_stat_gdpr_label(inputs)
	if (locale === "pl") return pl_landing_stat_gdpr_label(inputs)
	if (locale === "fi") return fi_landing_stat_gdpr_label(inputs)
	if (locale === "da") return da_landing_stat_gdpr_label(inputs)
	if (locale === "sv") return sv_landing_stat_gdpr_label(inputs)
	return en_landing_stat_gdpr_label(inputs)
});